const DEFAULT = "ru"

const data = (state = DEFAULT, action) => {

    let store = state

    if (action.type === 'SET_LANGUAGE') {
        store = action.payload
    }

    return store
}

export default data